module.exports = __webpack_public_path__ + "static/media/9-Spades.78fd3e59.svg";